export default __webpack_public_path__ + "images/sweep6.1ec087d083a7308d6e440c5403b34e73.png";